import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-info",
  "use": "icon-info-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-info\"><defs><style type=\"text/css\"></style></defs><path d=\"M859.8 823.4C937.5 728 932 587.2 843 498.3c-47.5-47.5-109.6-71.2-171.8-71.2-62.2 0-124.4 23.7-171.8 71.2-94.9 94.9-94.9 248.8 0 343.7 47.4 47.4 109.6 71.2 171.8 71.2 54.4 0 108.7-18.1 153.3-54.4l99.9 99.9 35.4-35.4-100-99.9zM821 791.8l-12.6 15.5-15.6 12.7c-17.3 14.1-36.8 25-57.8 32.4-20.5 7.2-42 10.8-63.8 10.8-51.6 0-100-20.1-136.5-56.5-36.5-36.5-56.5-84.9-56.5-136.5 0-51.6 20.1-100 56.5-136.5 36.5-36.5 84.9-56.5 136.5-56.5 51.6 0 100 20.1 136.5 56.5 34 34 54 79.2 56.3 127.1 2.2 47.7-13 94.2-43 131z\" fill=\"\" p-id=\"1201\" /><path d=\"M432 910H172V114h680v288h50V64H122v896h310z\" fill=\"\" p-id=\"1202\" /><path d=\"M262 281h500v50H262zM262 441.1h130v50H262zM262 601.2h130v50H262z\" fill=\"\" p-id=\"1203\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/info.svg
// module id = Yfis
// module chunks = 1